<div class="login-page">
  <app-login-scene class="login-scene"></app-login-scene>

  <main class="login-panel">
    <header class="panel-top">
      <a class="panel-brand" href="https://measuremaponline.com" [attr.aria-label]="strings['login_back_to_website']">
        <img src="/assets/images/app-logo.svg" alt="" width="30" height="26">
        <span>{{strings['app_name']}}</span>
      </a>
      <div class="panel-tools">
        <label class="lang-picker" [title]="strings['language']">
          <mat-icon aria-hidden="true">language</mat-icon>
          <select [attr.aria-label]="strings['language']" (change)="changeLanguage($any($event.target).value)">
            @for (l of languageList; track l) {
              <option [value]="l" [selected]="l === language">{{getLanguageName(l)}}</option>
            }
          </select>
          <mat-icon class="lang-chevron" aria-hidden="true">expand_more</mat-icon>
        </label>
        <button type="button" class="icon-btn" (click)="toggleTheme()"
                [attr.aria-label]="isDark ? strings['login_theme_light'] : strings['login_theme_dark']"
                [title]="isDark ? strings['login_theme_light'] : strings['login_theme_dark']">
          @if (isDark) {
            <mat-icon class="theme-icon" aria-hidden="true">light_mode</mat-icon>
          } @else {
            <mat-icon class="theme-icon" aria-hidden="true">dark_mode</mat-icon>
          }
        </button>
      </div>
    </header>

    <div class="panel-body">
      <div class="stage">
        @switch (uiType) {

          <!-- ── Sign in ─────────────────────────────────────────── -->
          @case (uiTypes.login) {
            <section class="screen" animate.enter="screen-in" animate.leave="screen-out" aria-labelledby="signin-title">
              <div class="screen-head">
                <h1 id="signin-title" class="title">{{strings['login_title_sign_in']}}</h1>
                <p class="subtitle">{{strings['login_sub_sign_in']}}</p>
              </div>

              @if (notice) {
                <div class="alert" role="alert">
                  <mat-icon aria-hidden="true">error_outline</mat-icon>
                  <span>{{notice}}</span>
                </div>
              }

              <button type="button" class="btn btn-google" [class.is-busy]="busyAction === 'google'"
                      [disabled]="working" [attr.aria-busy]="busyAction === 'google'" (click)="signInWithGoogle()">
                <span class="btn-label">
                  <ng-container *ngTemplateOutlet="googleMark"></ng-container>
                  {{strings['login_continue_google']}}
                </span>
                <span class="btn-spinner" aria-hidden="true"></span>
              </button>

              <div class="divider" aria-hidden="true"><span>{{strings['login_or']}}</span></div>

              <form class="form" novalidate (ngSubmit)="submitSignIn()">
                <div class="field mmf-wrap" [class.mmf-error]="errors.email">
                  <label class="mmf-label" for="signin-email">{{strings['email']}}</label>
                  <div class="mmf-control">
                    <span class="mmf-prefix"><i class="material-icons" aria-hidden="true">mail_outline</i></span>
                    <input id="signin-email" class="mm-input" type="email" name="email" autocomplete="username"
                           inputmode="email" autocapitalize="off" spellcheck="false" maxlength="254"
                           data-field="email" data-autofocus
                           [placeholder]="strings['login_email_placeholder']"
                           [attr.aria-invalid]="!!errors.email"
                           [attr.aria-describedby]="errors.email ? 'signin-email-error' : null"
                           [(ngModel)]="form.email" (ngModelChange)="clearError('email')">
                  </div>
                  @if (errors.email) {
                    <div class="mmf-error-msg" id="signin-email-error">{{strings[errors.email]}}</div>
                  }
                </div>

                <div class="field mmf-wrap" [class.mmf-error]="errors.password">
                  <label class="mmf-label" for="signin-password">{{strings['password']}}</label>
                  <div class="mmf-control">
                    <span class="mmf-prefix"><i class="material-icons" aria-hidden="true">lock_outline</i></span>
                    <input id="signin-password" class="mm-input" [type]="showPassword ? 'text' : 'password'"
                           name="password" autocomplete="current-password" maxlength="128" data-field="password"
                           [attr.aria-invalid]="!!errors.password"
                           [attr.aria-describedby]="errors.password ? 'signin-password-error' : null"
                           [(ngModel)]="form.password" (ngModelChange)="clearError('password')"
                           (keydown)="onPasswordKey($event)" (keyup)="onPasswordKey($event)" (blur)="capsLock = false">
                    <ng-container *ngTemplateOutlet="revealToggle"></ng-container>
                  </div>
                  @if (errors.password) {
                    <div class="mmf-error-msg" id="signin-password-error">{{strings[errors.password]}}</div>
                  }
                  <div class="field-meta">
                    @if (capsLock) {
                      <span class="caps-hint"><mat-icon aria-hidden="true">keyboard_capslock</mat-icon>{{strings['login_caps_lock_on']}}</span>
                    }
                    <button type="button" class="link link-sm" (click)="setUiType(uiTypes.forgot_password)">
                      {{strings['forgot_password']}}
                    </button>
                  </div>
                </div>

                <div class="form-note" aria-live="assertive" aria-atomic="true">
                  @if (note) {
                    <div class="alert"><mat-icon aria-hidden="true">error_outline</mat-icon><span>{{note}}</span></div>
                  }
                </div>

                <button type="submit" class="btn btn-primary" [class.is-busy]="busyAction === 'form'"
                        [disabled]="working" [attr.aria-busy]="busyAction === 'form'">
                  <span class="btn-label">{{strings['login_sign_in_button']}}</span>
                  <span class="btn-spinner" aria-hidden="true"></span>
                </button>
              </form>

              <p class="switch">
                {{strings['login_no_account']}}
                <button type="button" class="link" (click)="setUiType(uiTypes.register)">{{strings['login_create_account']}}</button>
              </p>
              <p class="switch switch-quiet">
                <button type="button" class="link link-quiet" (click)="startSso()">
                  <mat-icon aria-hidden="true">domain</mat-icon>{{strings['login_sso_link']}}
                </button>
              </p>
            </section>
          }

          <!-- ── Create an account ───────────────────────────────── -->
          @case (uiTypes.register) {
            <section class="screen" animate.enter="screen-in" animate.leave="screen-out" aria-labelledby="register-title">
              <div class="screen-head">
                <h1 id="register-title" class="title">{{strings['login_title_register']}}</h1>
                <p class="subtitle">{{strings['login_sub_register']}}</p>
              </div>

              <button type="button" class="btn btn-google" [class.is-busy]="busyAction === 'google'"
                      [disabled]="working" [attr.aria-busy]="busyAction === 'google'" (click)="signInWithGoogle()">
                <span class="btn-label">
                  <ng-container *ngTemplateOutlet="googleMark"></ng-container>
                  {{strings['login_continue_google']}}
                </span>
                <span class="btn-spinner" aria-hidden="true"></span>
              </button>

              <div class="divider" aria-hidden="true"><span>{{strings['login_or']}}</span></div>

              <form class="form" novalidate (ngSubmit)="submitRegister()">
                <div class="field-pair">
                  <div class="field mmf-wrap" [class.mmf-error]="errors.fullName">
                    <label class="mmf-label" for="register-name">{{strings['full_name']}}</label>
                    <div class="mmf-control">
                      <input id="register-name" class="mm-input" type="text" name="fullname"
                             autocomplete="name" maxlength="40" data-field="fullName" data-autofocus
                             [attr.aria-invalid]="!!errors.fullName"
                             [attr.aria-describedby]="errors.fullName ? 'register-name-error' : null"
                             [(ngModel)]="form.fullName" (ngModelChange)="clearError('fullName')">
                    </div>
                    @if (errors.fullName) {
                      <div class="mmf-error-msg" id="register-name-error">{{strings[errors.fullName]}}</div>
                    }
                  </div>
                  <div class="field mmf-wrap">
                    <label class="mmf-label" for="register-company">
                      {{strings['company']}} <span class="field-optional">{{strings['optional']}}</span>
                    </label>
                    <div class="mmf-control">
                      <input id="register-company" class="mm-input" type="text" name="company"
                             autocomplete="organization" maxlength="40" [(ngModel)]="form.company">
                    </div>
                  </div>
                </div>

                <div class="field mmf-wrap" [class.mmf-error]="errors.email">
                  <label class="mmf-label" for="register-email">{{strings['email']}}</label>
                  <div class="mmf-control">
                    <span class="mmf-prefix"><i class="material-icons" aria-hidden="true">mail_outline</i></span>
                    <input id="register-email" class="mm-input" type="email" name="email" autocomplete="email"
                           inputmode="email" autocapitalize="off" spellcheck="false" maxlength="254" data-field="email"
                           [placeholder]="strings['login_email_placeholder']"
                           [attr.aria-invalid]="!!errors.email"
                           [attr.aria-describedby]="errors.email ? 'register-email-error' : null"
                           [(ngModel)]="form.email" (ngModelChange)="clearError('email')">
                  </div>
                  @if (errors.email) {
                    <div class="mmf-error-msg" id="register-email-error">{{strings[errors.email]}}</div>
                  }
                </div>

                <div class="field mmf-wrap" [class.mmf-error]="errors.password">
                  <label class="mmf-label" for="register-password">{{strings['password']}}</label>
                  <div class="mmf-control">
                    <span class="mmf-prefix"><i class="material-icons" aria-hidden="true">lock_outline</i></span>
                    <input id="register-password" class="mm-input" [type]="showPassword ? 'text' : 'password'"
                           name="new-password" autocomplete="new-password" maxlength="128" data-field="password"
                           [attr.aria-invalid]="!!errors.password"
                           aria-describedby="register-password-help"
                           [(ngModel)]="form.password" (ngModelChange)="clearError('password')"
                           (keydown)="onPasswordKey($event)" (keyup)="onPasswordKey($event)" (blur)="capsLock = false">
                    <ng-container *ngTemplateOutlet="revealToggle"></ng-container>
                  </div>
                  <div id="register-password-help" class="strength" [attr.data-score]="passwordScore">
                    <div class="strength-bar" aria-hidden="true"><i></i><i></i><i></i><i></i></div>
                    <div class="strength-text">
                      @if (errors.password) {
                        <span class="mmf-error-msg">{{strings[errors.password]}}</span>
                      } @else if (capsLock) {
                        <span class="caps-hint"><mat-icon aria-hidden="true">keyboard_capslock</mat-icon>{{strings['login_caps_lock_on']}}</span>
                      } @else {
                        <span>{{strings['password_min_length']}}</span>
                      }
                      @if (passwordScore) {
                        <span class="strength-label">{{strings[passwordScoreKey]}}</span>
                      }
                    </div>
                  </div>
                </div>

                <div class="field mmf-wrap" [class.mmf-error]="errors.repeatPassword || repeatMismatch">
                  <label class="mmf-label" for="register-repeat">{{strings['repeat_password']}}</label>
                  <div class="mmf-control">
                    <span class="mmf-prefix"><i class="material-icons" aria-hidden="true">lock_outline</i></span>
                    <input id="register-repeat" class="mm-input" [type]="showPassword ? 'text' : 'password'"
                           name="repeat-password" autocomplete="new-password" maxlength="128" data-field="repeatPassword"
                           [attr.aria-invalid]="!!errors.repeatPassword || repeatMismatch"
                           [attr.aria-describedby]="(errors.repeatPassword || repeatMismatch) ? 'register-repeat-error' : null"
                           [(ngModel)]="form.repeatPassword" (ngModelChange)="clearError('repeatPassword')"
                           (keydown)="onPasswordKey($event)" (keyup)="onPasswordKey($event)" (blur)="capsLock = false">
                    @if (form.repeatPassword && form.repeatPassword === form.password) {
                      <span class="mmf-suffix field-ok" aria-hidden="true"><i class="material-icons">check_circle</i></span>
                    }
                  </div>
                  @if (errors.repeatPassword || repeatMismatch) {
                    <div class="mmf-error-msg" id="register-repeat-error">{{strings['passwords_do_not_match']}}</div>
                  }
                </div>

                <div class="form-note" aria-live="assertive" aria-atomic="true">
                  @if (note) {
                    <div class="alert"><mat-icon aria-hidden="true">error_outline</mat-icon><span>{{note}}</span></div>
                  }
                </div>

                <button type="submit" class="btn btn-primary" [class.is-busy]="busyAction === 'form'"
                        [disabled]="working" [attr.aria-busy]="busyAction === 'form'">
                  <span class="btn-label">{{strings['login_create_account_button']}}</span>
                  <span class="btn-spinner" aria-hidden="true"></span>
                </button>

                @let terms = split('login_register_terms');
                <p class="fineprint">
                  {{terms[0]}}<a href="https://measuremaponline.com/terms" target="_blank" rel="noopener">{{strings['login_terms_link']}}</a>{{terms[1]}}<a href="https://measuremaponline.com/privacy" target="_blank" rel="noopener">{{strings['login_privacy_link']}}</a>{{terms[2]}}
                </p>
              </form>

              <p class="switch">
                {{strings['login_have_account']}}
                <button type="button" class="link" (click)="setUiType(uiTypes.login)">{{strings['login_sign_in_link']}}</button>
              </p>
            </section>
          }

          <!-- ── Forgot password ─────────────────────────────────── -->
          @case (uiTypes.forgot_password) {
            @if (!resetSent) {
              <section class="screen" animate.enter="screen-in" animate.leave="screen-out" aria-labelledby="forgot-title">
                <button type="button" class="back" (click)="setUiType(uiTypes.login)">
                  <mat-icon aria-hidden="true">arrow_back</mat-icon>{{strings['login_back_to_sign_in']}}
                </button>
                <div class="screen-head">
                  <h1 id="forgot-title" class="title">{{strings['login_title_forgot']}}</h1>
                  <p class="subtitle">{{strings['login_sub_forgot']}}</p>
                </div>
                <form class="form" novalidate (ngSubmit)="submitReset()">
                  <div class="field mmf-wrap" [class.mmf-error]="errors.email">
                    <label class="mmf-label" for="forgot-email">{{strings['email']}}</label>
                    <div class="mmf-control">
                      <span class="mmf-prefix"><i class="material-icons" aria-hidden="true">mail_outline</i></span>
                      <input id="forgot-email" class="mm-input" type="email" name="email" autocomplete="username"
                             inputmode="email" autocapitalize="off" spellcheck="false" maxlength="254"
                             data-field="email" data-autofocus
                             [placeholder]="strings['login_email_placeholder']"
                             [attr.aria-invalid]="!!errors.email"
                             [attr.aria-describedby]="errors.email ? 'forgot-email-error' : null"
                             [(ngModel)]="form.email" (ngModelChange)="clearError('email')">
                    </div>
                    @if (errors.email) {
                      <div class="mmf-error-msg" id="forgot-email-error">{{strings[errors.email]}}</div>
                    }
                  </div>

                  <div class="form-note" aria-live="assertive" aria-atomic="true">
                    @if (note) {
                      <div class="alert"><mat-icon aria-hidden="true">error_outline</mat-icon><span>{{note}}</span></div>
                    }
                  </div>

                  <!-- Back here within a minute of sending: the wait is shown, not a dead button. -->
                  <button type="submit" class="btn btn-primary" [class.is-busy]="busyAction === 'form'"
                          [disabled]="working || resetCooldown > 0" [attr.aria-busy]="busyAction === 'form'">
                    <span class="btn-label">
                      {{resetCooldown > 0 ? getString('login_resend_in', '' + resetCooldown) : strings['login_send_link']}}
                    </span>
                    <span class="btn-spinner" aria-hidden="true"></span>
                  </button>
                </form>
              </section>
            } @else {
              <section class="screen screen-center" animate.enter="screen-in" animate.leave="screen-out" aria-labelledby="sent-title">
                <div class="badge badge-mail" aria-hidden="true"><mat-icon>mark_email_read</mat-icon></div>
                <div class="screen-head">
                  <h1 id="sent-title" class="title" tabindex="-1" data-autofocus>{{strings['login_title_check_inbox']}}</h1>
                  @let sent = split('login_reset_sent_text');
                  <p class="subtitle">{{sent[0]}}<strong>{{form.email}}</strong>{{sent[1]}}</p>
                </div>

                <div class="form-note" aria-live="polite" aria-atomic="true">
                  @if (note) {
                    <div class="alert"><mat-icon aria-hidden="true">error_outline</mat-icon><span>{{note}}</span></div>
                  } @else if (resendDone) {
                    <div class="status"><mat-icon aria-hidden="true">check_circle</mat-icon><span>{{strings['login_email_sent']}}</span></div>
                  }
                </div>

                <button type="button" class="btn btn-primary" (click)="setUiType(uiTypes.login)">
                  <span class="btn-label">{{strings['login_back_to_sign_in']}}</span>
                </button>
                <button type="button" class="btn btn-quiet" [class.is-busy]="busyAction === 'form'"
                        [disabled]="working || resetCooldown > 0" (click)="resendReset()">
                  <span class="btn-label">
                    {{resetCooldown > 0 ? getString('login_resend_in', '' + resetCooldown) : strings['login_resend_email']}}
                  </span>
                  <span class="btn-spinner" aria-hidden="true"></span>
                </button>
              </section>
            }
          }

          <!-- ── Verify the email ────────────────────────────────── -->
          @case (uiTypes.verify_account) {
            <section class="screen screen-center" animate.enter="screen-in" animate.leave="screen-out" aria-labelledby="verify-title">
              <div class="badge badge-mail" aria-hidden="true"><mat-icon>mark_email_unread</mat-icon></div>
              <div class="screen-head">
                <h1 id="verify-title" class="title" tabindex="-1" data-autofocus>{{strings['login_title_verify']}}</h1>
                @let verify = split('login_verify_text');
                <p class="subtitle">{{verify[0]}}<strong>{{verifyEmailAddress}}</strong>{{verify[1]}}</p>
              </div>

              <div class="form-note" aria-live="polite" aria-atomic="true">
                @if (note) {
                  <div class="alert"><mat-icon aria-hidden="true">error_outline</mat-icon><span>{{note}}</span></div>
                }
              </div>

              <button type="button" class="btn btn-primary" [class.is-busy]="busyAction === 'form'"
                      [disabled]="working" [attr.aria-busy]="busyAction === 'form'" (click)="checkVerified()">
                <span class="btn-label">{{strings['login_verified_continue']}}</span>
                <span class="btn-spinner" aria-hidden="true"></span>
              </button>
              <button type="button" class="btn btn-quiet" [disabled]="!canVerifyEmail" (click)="sendVerificationEmail()">
                <span class="btn-label">
                  {{verifyCooldown > 0 ? getString('login_resend_in', '' + verifyCooldown) : strings['login_resend_email']}}
                </span>
              </button>
              <p class="switch">
                <button type="button" class="link" (click)="signOut()">{{strings['login_use_other_account']}}</button>
              </p>
            </section>
          }

          <!-- ── Second factor ───────────────────────────────────────
               Its own screen rather than more conditions on the login
               fields: the password is already accepted at this point, so
               showing it again would invite the user to re-enter it. -->
          @case (uiTypes.two_factor) {
            <section class="screen screen-center" animate.enter="screen-in" animate.leave="screen-out" aria-labelledby="mfa-title">
              <div class="badge" aria-hidden="true"><mat-icon>phonelink_lock</mat-icon></div>
              <div class="screen-head">
                <h1 id="mfa-title" class="title">{{strings['two_factor_title']}}</h1>
                <p class="subtitle">{{twoFactorPrompt}}</p>
              </div>
              <form class="form" novalidate (ngSubmit)="verifyTwoFactorCode()">
                <div class="field mmf-wrap" [class.mmf-error]="errors.twoFactorCode">
                  <label class="mmf-label sr-only" for="mfa-code">{{strings['verification_code']}}</label>
                  <div class="mmf-control">
                    <input id="mfa-code" class="mm-input code-input" type="text" name="oneTimeCode"
                           autocomplete="one-time-code" inputmode="numeric" pattern="[0-9]*" maxlength="6"
                           placeholder="000000" data-field="twoFactorCode" data-autofocus
                           [attr.aria-invalid]="!!errors.twoFactorCode"
                           [attr.aria-describedby]="errors.twoFactorCode ? 'mfa-code-error' : null"
                           [value]="twoFactorCode" (input)="onCodeInput($event)">
                  </div>
                  @if (errors.twoFactorCode) {
                    <div class="mmf-error-msg" id="mfa-code-error">{{strings[errors.twoFactorCode]}}</div>
                  }
                </div>

                <div class="form-note" aria-live="assertive" aria-atomic="true">
                  @if (note) {
                    <div class="alert"><mat-icon aria-hidden="true">error_outline</mat-icon><span>{{note}}</span></div>
                  }
                </div>

                <button type="submit" class="btn btn-primary" [class.is-busy]="verifyingTwoFactor"
                        [disabled]="verifyingTwoFactor" [attr.aria-busy]="verifyingTwoFactor">
                  <span class="btn-label">{{strings['verify']}}</span>
                  <span class="btn-spinner" aria-hidden="true"></span>
                </button>
              </form>
              <!-- The way out for someone whose authenticator is gone. Without
                   this the screen is a dead end and the account is lost. -->
              <p class="switch">
                {{strings['lost_your_device']}}
                <button type="button" class="link" (click)="startRecovery()">{{strings['recovery_title']}}</button>
              </p>
              <p class="switch switch-quiet">
                <button type="button" class="link link-quiet" (click)="cancelTwoFactor()">
                  <mat-icon aria-hidden="true">arrow_back</mat-icon>{{strings['login_back_to_sign_in']}}
                </button>
              </p>
            </section>
          }

          <!-- ── Recovery ────────────────────────────────────────────
               Removes the second factor rather than satisfying it: Firebase
               has no notion of backup codes, so there is nothing to hand its
               challenge. The password is re-sent because the server checks
               it again — this endpoint is open by necessity, and a recovery
               code alone must not be enough to take someone's factor off. -->
          @case (uiTypes.recovery) {
            <section class="screen" animate.enter="screen-in" animate.leave="screen-out" aria-labelledby="recovery-title">
              <button type="button" class="back" (click)="cancelRecovery()">
                <mat-icon aria-hidden="true">arrow_back</mat-icon>{{strings['back']}}
              </button>
              <div class="screen-head">
                <h1 id="recovery-title" class="title">{{strings['recovery_title']}}</h1>
                <p class="subtitle">{{strings['login_recovery_intro']}}</p>
              </div>
              <form class="form" novalidate (ngSubmit)="submitRecovery()">
                <div class="field mmf-wrap" [class.mmf-error]="errors.recoveryCode">
                  <label class="mmf-label" for="recovery-code">{{strings['recovery_code_label']}}</label>
                  <div class="mmf-control">
                    <span class="mmf-prefix"><i class="material-icons" aria-hidden="true">key</i></span>
                    <input id="recovery-code" class="mm-input field-input-mono" type="text" name="recoveryCode"
                           maxlength="16" autocomplete="off" autocapitalize="characters" spellcheck="false"
                           data-field="recoveryCode" data-autofocus
                           [attr.aria-invalid]="!!errors.recoveryCode"
                           [attr.aria-describedby]="errors.recoveryCode ? 'recovery-code-error' : null"
                           [(ngModel)]="recoveryCode" (ngModelChange)="clearError('recoveryCode')">
                  </div>
                  @if (errors.recoveryCode) {
                    <div class="mmf-error-msg" id="recovery-code-error">{{strings[errors.recoveryCode]}}</div>
                  }
                </div>

                <div class="form-note" aria-live="assertive" aria-atomic="true">
                  @if (note) {
                    <div class="alert"><mat-icon aria-hidden="true">error_outline</mat-icon><span>{{note}}</span></div>
                  }
                </div>

                <button type="submit" class="btn btn-primary" [class.is-busy]="recoveringTwoFactor"
                        [disabled]="recoveringTwoFactor" [attr.aria-busy]="recoveringTwoFactor">
                  <span class="btn-label">{{strings['continue']}}</span>
                  <span class="btn-spinner" aria-hidden="true"></span>
                </button>
              </form>
            </section>
          }

          <!-- ── Company sign-in code ────────────────────────────── -->
          @case (uiTypes.sso) {
            <section class="screen" animate.enter="screen-in" animate.leave="screen-out" aria-labelledby="sso-title">
              <button type="button" class="back" (click)="setUiType(uiTypes.login)">
                <mat-icon aria-hidden="true">arrow_back</mat-icon>{{strings['login_back_to_sign_in']}}
              </button>
              <div class="screen-head">
                <h1 id="sso-title" class="title">{{strings['login_title_sso']}}</h1>
                <p class="subtitle">{{strings['login_sub_sso']}}</p>
              </div>
              <form class="form" novalidate (ngSubmit)="submitSsoCode()">
                <div class="field mmf-wrap" [class.mmf-error]="errors.ssoCode">
                  <label class="mmf-label" for="sso-code">{{strings['login_sso_code_label']}}</label>
                  <div class="mmf-control">
                    <span class="mmf-prefix"><i class="material-icons" aria-hidden="true">domain</i></span>
                    <input id="sso-code" class="mm-input" type="text" name="ssoCode" autocomplete="off"
                           autocapitalize="off" spellcheck="false" maxlength="500" data-field="ssoCode" data-autofocus
                           [placeholder]="strings['login_sso_code_placeholder']"
                           [attr.aria-invalid]="!!errors.ssoCode"
                           [attr.aria-describedby]="errors.ssoCode ? 'sso-code-error' : 'sso-code-hint'"
                           [(ngModel)]="ssoCode" (ngModelChange)="clearError('ssoCode')">
                  </div>
                  @if (errors.ssoCode) {
                    <div class="mmf-error-msg" id="sso-code-error">{{strings[errors.ssoCode]}}</div>
                  } @else {
                    <div class="mmf-hint" id="sso-code-hint">{{strings['login_sso_code_hint']}}</div>
                  }
                </div>

                <div class="form-note" aria-live="assertive" aria-atomic="true">
                  @if (note) {
                    <div class="alert"><mat-icon aria-hidden="true">error_outline</mat-icon><span>{{note}}</span></div>
                  }
                </div>

                <button type="submit" class="btn btn-primary" [class.is-busy]="ssoLoading"
                        [disabled]="ssoLoading" [attr.aria-busy]="ssoLoading">
                  <span class="btn-label">{{strings['continue']}}</span>
                  <span class="btn-spinner" aria-hidden="true"></span>
                </button>
              </form>
            </section>
          }

          <!-- ── The organisation's sign-in ──────────────────────── -->
          @case (uiTypes.login_saml) {
            <section class="screen screen-center" animate.enter="screen-in" animate.leave="screen-out" aria-labelledby="org-title"
                     [attr.aria-busy]="ssoLoading">
              <div class="badge" aria-hidden="true"><mat-icon>domain</mat-icon></div>
              @if (ssoLoading || !ssoProvider) {
                <div class="screen-head">
                  <h1 id="org-title" class="title">{{strings['login_title_sso']}}</h1>
                  <p class="subtitle loading-line"><span class="dot-spinner" aria-hidden="true"></span>{{strings['login_sso_checking']}}</p>
                </div>
              } @else {
                <div class="screen-head">
                  <h1 id="org-title" class="title" tabindex="-1">{{getString('login_title_sso_provider', ssoProvider.name)}}</h1>
                  <p class="subtitle">{{getString('login_sub_sso_provider', ssoProvider.name)}}</p>
                </div>

                <div class="form-note" aria-live="assertive" aria-atomic="true">
                  @if (note) {
                    <div class="alert"><mat-icon aria-hidden="true">error_outline</mat-icon><span>{{note}}</span></div>
                  }
                </div>

                <button type="button" class="btn btn-primary" data-autofocus [class.is-busy]="busyAction === 'sso'"
                        [disabled]="working" [attr.aria-busy]="busyAction === 'sso'" (click)="signInWithSAML()">
                  <span class="btn-label">{{getString('login_continue_with', ssoProvider.name)}}</span>
                  <span class="btn-spinner" aria-hidden="true"></span>
                </button>
              }
              <p class="switch switch-quiet">
                <button type="button" class="link link-quiet" (click)="setUiType(uiTypes.login)">
                  <mat-icon aria-hidden="true">arrow_back</mat-icon>{{strings['login_other_ways']}}
                </button>
              </p>
            </section>
          }
        }
      </div>
    </div>

    <footer class="panel-foot">
      <nav class="foot-links" [attr.aria-label]="strings['login_footer_links']">
        <a href="https://help.measuremaponline.com" target="_blank" rel="noopener">{{strings['login_help_centre']}}</a>
        <a href="https://measuremaponline.com/privacy" target="_blank" rel="noopener">{{strings['login_privacy_short']}}</a>
        <a href="https://measuremaponline.com/terms" target="_blank" rel="noopener">{{strings['login_terms_short']}}</a>
        <a href="/cookies">{{strings['login_cookies_short']}}</a>
        <a href="" (click)="$event.preventDefault(); openCookieSettings()">{{strings['cookie_settings']}}</a>
      </nav>
      <a class="foot-company" href="https://blueblinkone.com" target="_blank" rel="noopener">
        <img src="/assets/images/blueblinkone_symbol.svg" alt="" width="16" height="16">
        <span>{{getString('login_copyright', '' + year)}}</span>
      </a>
    </footer>
  </main>
</div>

<!-- Google's own "G", as its branding guidelines require (four colours, never recoloured). -->
<ng-template #googleMark>
  <svg class="google-mark" viewBox="0 0 48 48" aria-hidden="true" focusable="false">
    <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
    <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
    <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
    <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
  </svg>
</ng-template>

<!-- Show / hide the password (both password fields follow it on the register screen). -->
<ng-template #revealToggle>
  <button type="button" class="mmf-suffix field-toggle" (click)="showPassword = !showPassword"
          [attr.aria-label]="showPassword ? strings['login_hide_password'] : strings['login_show_password']"
          [attr.aria-pressed]="showPassword"
          [title]="showPassword ? strings['login_hide_password'] : strings['login_show_password']">
    <i class="material-icons" aria-hidden="true">{{showPassword ? 'visibility_off' : 'visibility'}}</i>
  </button>
</ng-template>
